import Vue from 'vue'
import App from './App.vue'
import "/src/assets/css/reset.css"
import ElementUI from 'element-ui';
import './theme/index.css';
import router from './router'
import store from './store';
import {doGet, doPost, downLoad} from "@/utils/http";
import Router from 'vue-router'
import './assets/css/innerHeader.less';
import commonUtil from "@/utils/commonUtil";

Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: "medium",
})

Vue.prototype.$doPost = doPost
Vue.prototype.$doGet= doGet
Vue.prototype.$download= downLoad
Vue.prototype.$commonUtil = commonUtil;


Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 权限指令,对按钮权限的控制
const has = Vue.directive("has", {
  inserted: function(el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el);
    }
  },
});
// 权限检查方法
Vue.prototype.$_has = function(value) {
  let isExist = false;
  let permissionsStr = localStorage.getItem("permissions")
  if (permissionsStr === undefined || permissionsStr === null) {
    return false;
  }

  let permissions = JSON.parse(permissionsStr);
  if (permissions[value]) {
    isExist = true;
  }
  return isExist;
};
export { has };

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
